import React from "react";
import { cn } from "@/lib/utils";

type BadgeProps = React.HTMLAttributes<HTMLDivElement> & {
  variant?: "default" | "secondary" | "danger" | "success" | "outline" | "primary";
};

const Badge: React.FC<BadgeProps> = ({
  className,
  variant = "default",
  children,
  ...props
}) => {
  const variants = {
    default: "bg-surface-hover text-text-primary",
    secondary: "bg-surface text-muted",
    danger: "bg-error text-button-text",
    success: "bg-success text-button-text",
    primary: "bg-primary text-button-text",
    outline: "border border-current bg-transparent",
  };

  return (
    <div
      className={cn(
        "inline-flex items-center rounded-full px-1.5 py-0.5 text-xs font-semibold",
        variants[variant],
        className
      )}
      {...props}
    >
      {children}
    </div>
  );
};

export { Badge };
export default Badge;
